import { ProductSize } from "./ProductSize.js";

export const maxLabels = 3;
export const maxCharactersPerLabel = 20;

export const maxCharactersForInscription = 25;

export const maxNumbers = 2;
export const minNumber = 1;
export const maxNumber = 999;

export const maxStandingPhotos = 3;

export const minMacaroons = 1;
export const maxMacaroonsPerSize: Record<ProductSize, number> = {
	[ProductSize.Xs]: 3,
	[ProductSize.S]: 8,
	[ProductSize.M]: 12,
	[ProductSize.L]: 20,
};

export const themedMacaroonsCount = 10;
export const themedMacaroonsPrice = 550;
export const themedCupcakesCount = 9;
export const themedCupcakesPrice = 765;

export const maxFigurines = 3;
export const minFigurinePrice = 350;
